import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

/**
 * El marco de lo que se ve dentro de una pestaña: una hoja centrada, de ancho de lectura (no
 * se estira a todo el monitor), sin velo ni fondo borroso. Nunca es más alta que su sitio: quien
 * la usa pone un cuerpo que se desplaza (`min-h-0 flex-1 overflow-y-auto`) y, si tiene botones,
 * un pie `shrink-0` que queda siempre a la vista.
 */
export function HojaDePestana({ nombre, ancho = 'max-w-2xl', children }: { nombre: string; ancho?: string; children: ReactNode }) {
  return (
    <section
      aria-label={nombre}
      className={cn(
        'mx-auto flex max-h-full w-full flex-col overflow-hidden rounded-lg border border-surface-border bg-white shadow-sm',
        'dark:border-slate-800 dark:bg-slate-900',
        ancho,
      )}
    >
      {children}
    </section>
  );
}

/** Lo que se dice cuando el registro de una pestaña ya no existe: qué pasó y cómo salir. */
export function PestanaSinRegistro({ nombre, mensaje, onCerrar }: { nombre: string; mensaje: string; onCerrar: () => void }) {
  return (
    <HojaDePestana nombre={nombre} ancho="max-w-md">
      <div className="space-y-3 p-6 text-sm text-slate-600 dark:text-slate-300">
        <p>{mensaje}</p>
        <button
          type="button"
          onClick={onCerrar}
          className="inline-flex min-h-[44px] items-center rounded-md border border-surface-border px-3 text-sm font-medium text-slate-700 hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 md:min-h-0 md:py-1.5 dark:border-slate-700 dark:text-slate-200 dark:hover:bg-slate-800"
        >
          Cerrar la pestaña
        </button>
      </div>
    </HojaDePestana>
  );
}
